/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Booking_Link_Contact_InvalidInputs */

const en_error_booking_link_contact_invalid = /** @type {(inputs: Error_Booking_Link_Contact_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This contact cannot get a link: not a contact of a customer, archived, or without an email.`)
};

/**
* | output |
* | --- |
* | "This contact cannot get a link: not a contact of a customer, archived, or without an email." |
*
* @param {Error_Booking_Link_Contact_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_booking_link_contact_invalid = /** @type {((inputs?: Error_Booking_Link_Contact_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Booking_Link_Contact_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_booking_link_contact_invalid(inputs)
});